import Survey1PurposePrinciplesSelfInventory from "src/assets/video-champion-101/Survey1PurposePrinciplesSelfInventory.mp4";
import Survey2PurposePrinciplesPlayerSurvey from "src/assets/video-champion-101/Survey2PurposePrinciplesPlayerSurvey.mp4";
import Survey3TEAMSelfInventory from "src/assets/video-champion-101/Survey3TEAMSelfInventory.mp4";
import Survey4TEAMOthersSurvey from "src/assets/video-champion-101/Survey4TEAMOthersSurvey.mp4";

export interface ILevel {
  id: number;
  shortName: string;
  categoryLabel: string;
  pageTitle: string;
  intro: string;
  /** Optional bullet points rendered under the intro paragraph. */
  introBullets?: string[];
  /** Set when you have a YouTube embed ID (the part after youtube.com/watch?v=). */
  videoSrc: string | null;
  posterSrc?: string;
  externalVideoUrl?: string | null;
}

export const Levels: ILevel[] = [
  {
    id: 1,
    shortName: "Purpose Development",
    categoryLabel: "LEVEL ONE: PURPOSE DEVELOPMENT",
    pageTitle: "PURPOSE PRINCIPLES SELF-INVENTORY",
    intro:
      "As you wrap up Level One in the Champions 101 Coaches Academy, complete this short personal survey – powered by Grit Leadership – on how effectively you implement the principles of purpose-driven coaching. Watch the short video for instructions, then click the button below to get started.",
    videoSrc: Survey1PurposePrinciplesSelfInventory,
  },
  {
    id: 2,
    shortName: "Purpose Development",
    categoryLabel: "LEVEL ONE: PURPOSE DEVELOPMENT",
    pageTitle: "PURPOSE PRINCIPLES PLAYER SURVEY",
    intro:
      "As you wrap up Level One in the Champions 101 Coaches Academy, have your players complete this short survey – powered by Grit Leadership – on how effectively you put the principles of purpose-driven coaching into practice. Watch the short video for instructions, then click the button below to get started.",
    introBullets: [
      "Who should complete this survey? Your current players. You can send as many invitations as you’d like using the link you’ll receive on the next page.",
      "When should they complete it? We'd recommend anytime from a month into the season through its conclusion.",
      "How long do they have to complete it? Once you receive the survey link, participants have 72 hours to respond.",
      "What happens after they complete it? You'll receive a detailed report outlining the results.",
      "How often should they complete the survey? As often as you'd like, but we'd suggest one time per season.",
    ],
    videoSrc: Survey2PurposePrinciplesPlayerSurvey,
  },
  {
    id: 3,
    shortName: "Perspective Development",
    categoryLabel: "LEVEL TWO: PERSPECTIVE DEVELOPMENT",
    pageTitle: "T.E.A.M. FRAMEWORK SELF-INVENTORY",
    intro:
      "As you wrap up Level Two in the Champions 101 Coaches Academy, complete this short personal survey – powered by Grit Leadership – on your performance in each of the four T.E.A.M. framework areas: your teaching, your encouragement, your accountability, and your modeling. Watch the short video for instructions, then click the button below to get started.",
    videoSrc: Survey3TEAMSelfInventory,
  },
  {
    id: 4,
    shortName: "Perspective Development",
    categoryLabel: "LEVEL TWO: PERSPECTIVE DEVELOPMENT",
    pageTitle: "T.E.A.M. FRAMEWORK OTHERS SURVEY",
    intro:
      "As you wrap up Level Two in the Champions 101 Coaches Academy, share this short survey – powered by Grit Leadership – with people who can evaluate your performance in each of the four T.E.A.M. framework areas: your teaching, your encouragement, your accountability, and your modeling. Watch the short video for instructions, then click the button below to get started.",
    introBullets: [
      "Who should complete this survey? Anyone who’s observed your coaching up close. Some possible participants might include your athletic director, your assistant coaches, your former players, or your current players. You can send as many invitations as you’d like using the link you’ll receive on the next page.",
      "When should they complete it? This might be a great off-season or post-season evaluation tool.",
      "How long do they have to complete it? Once you receive the survey link, participants have 72 hours to respond.",
      "What happens after they complete it? You'll receive a detailed report outlining the results.",
      "How often should they complete the survey? As often as you'd like, but we'd suggest once a year.",
    ],
    videoSrc: Survey4TEAMOthersSurvey,
  },
];

export function getLevel(levelId: number): ILevel | undefined {
  return Levels.find((l) => l.id === levelId);
}



// WEBPACK FOOTER //
// ./src/features/home/pages/embed/levels.ts